/**
 * StarterAccountsConfig
 * Curated list of accounts shown to logged-out users
 *
 * These accounts provide a preview of Nostr content
 * to help new users understand what the network offers.
 */

export const STARTER_ACCOUNTS: string[] = [
  'npub10wv37amdqnv8edw5yktgsxr62g8k4lqkk2u66fk6c6uwuakzssxsf4v22x',
  'npub1lrnvvs6z78s9yjqxxr38uyqkmn34lsaxznnqgd877j4z2qej3j5s09qnw5',
  'npub1rtlqca8r6auyaw5n5h3l5422dm4sry5dzfee4696fqe8s6qgudks7djtfs',

  'npub18rdmnvrajwrp6srzpttz63934r58sh0sn9lwk3z57ykjzuzge4wqu6dhce',
  'npub1f4uyypghstsd8l4sxng4ptwzk6awfm3mf9ux0yallfrgkm6mj6es50r407',
  'npub1ymt2j3n8tesrlr0yhaheem6yyqmmwrr7actslurw6annls6vnrcslapxnz',
  'npub1ya6ds0y0j7yutq6pg2ftzxfvgdzaklls64g75vh0522c7svj7mjs9cug3q',
  'npub1qspus6smkn8mcdxg5jflh50s69vdgtwsd5p74gmjpzp2qekn5duqfv5afj',
  'npub1sk7mtp67zy7uex2f3dr5vdjynzpwu9dpc7q4f2c8cpjmguee6eeq56jraw',
  'npub17veg2gt7ja4dnjhs23jyttvpqlde3ajevlxuumxwghnqmgqwuv4q78cc5z',
  'npub1zw0uc6anqjeg0xt5ckwd5cwcd4updt22crecaea8yn053qrquewswctfhf',
  'npub1qupwscvtm4d2u7xl6mwz947z7wav5jhy2zjjelyx69geug0vxfdsp3na9r',
  'npub1uzfp6cgwue2njm86cmyeq7m26y0n58w72acq98sjsnnv4c87002s6857h3',
  'npub14hq5lgadtyy9dhvtszq46dnl0s0xwdddqr7e32rdqqhma8a4xhsspxjjzu',
  'npub1ukq58aunujlcqkjd7mxuq2y7x54neuy20vlx474038w5j7ls7jnq3qs4c6',
  'npub1q35eqc6rvdeejcwn47j0cgjp6mmxttx3yj3rlsvf43cy6a8y6zfq5mfg5m',
  'npub10vlhsqm4qar0g42p8g3plqyktmktd8hnprew45w638xzezgja95qapsp42',
  'npub14expwcsvnvaqgylaqx0a06vrmfpmyzq7w956hm9hwexrxw5mllcsymcqa0',
  'npub14d7ezuzsy55f6c2f4k02r27yeexyj42a7uvsfu53xmpzx7z75mmsnw0xv0',
  'npub1a2cww4kn9wqte4ry70vyfwqyqvpswksna27rtxd8vty6c74era8sdcw83a',
  'npub1m4ny6hjqzepn4rxknuq94c2gpqzr29ufkkw7ttcxyak7v43n6vvsajc2jl',
  'npub12u56mxg60cxt3zt3emfrfp6czptep4g3vzsfkgksmreeefmzmcgsuye0ve',
  'npub1vdaz78d96t7pjakpfmqqlr4wgq26l6vmkf25782n05qgdgtfmk8s297rjz',
  'npub1ha3a6lkrsnhx2s79ly4xwqsujy8ckt76tg4f7u4hkgr367x3x4esj2wvdg',
  'npub1l9kr6ajfwp6vfjp60vuzxwqwwlw884dff98a9cznujs520shsf9s35xfwh',
  'npub18dlusgmprudw46nracaldxe9hz4pdmrws8g6lsusy6qglcv5x48s0lh8x3',
  'npub1vzjukpr2vrxqg2m9q3a996gpzx8qktg82vnl9jlxp7a9yawnwxfsqnx9gc',
  'npub15dccx7yuxu6gs5ak4elylwxzgxucxy6qdm3ztlfmluwfr7n2u9hq4ug5zv',
  'npub12rv5lskctqxxs2c8rf2zlzc7xx3qpvzs3w4etgemauy9thegr43sf485vg',
  'npub1tjkc9jycaenqzdc3j3wkslmaj4ylv3dqzxzx0khz7h38f3vc6mls4ys9w3',
  'npub10r8xl2njyepcw2zwv3a6dyufj4e4ajx86hz6v4ehu4gnpupxxp7stjt2p8',
  'npub1p6t6gjhy3q4rfmcxuff7hu3xh5u09cvzem98d48arfzsrzd9kxws3cpeyl',
  'npub172y2yf9xrdekr25acsdfp2ag5t0lg4zdkz7rseegucuty8dp0ykq2ug6ef',
  'npub1s33sw6y2p8kpz2t8avz5feu2n6yvfr6swykrnm2frletd7spnt5qew252p',
  'npub1udl6vunzvrxzx46lrlpztjknwyjdclg9n8qp77vrrjuhh43xgyjsu3kpa8',
  'npub1drqqpmltrhlc0mr986hwqaceklsdf53dxawf4tuh4ev67q6c4wyscsyx6e',
  'npub16jdfqgazrkapk0yrqm9rdxlnys7ck39c7zmdzxtxqlmmpxg04r0sd733sv',
  'npub1cllf97qv29kqc493t6xj26kqw2qsxmvnf6sl7w0mpnv2plt8wumqta3zny',
  'npub1ehkvx8rdjsrwnf7kkqr8gy42vcwe6vwgqdwrl4juqccp689v8wfqr3mz4s',
  'npub1v7k63c6y2vktlqhsuupywt3yc7ykursujc34at964f9cv9s9y9csjutfk0',
  'npub1hxp75sgvu36q2xavu4067md89tdaeqcjr0dt2nxaar2m82cjv6esznw6td',
  'npub1uwjejfyn8j0e7t0cx3ys2h4nsk83fq8a6rz7mw2a7z97mnfwvcjqcvaxfl',
  'npub1tuw5xsgy5t9d2hxwu6d3qmx5cyyh00hqzgswvwstkq893t7splkswp8560',
  'npub175nul9cvufswwsnpy99lvyhg7ad9nkccxhkhusznxfkr7e0zxthql9g6w0',
  'npub1nje4ghpkjsxe5thcd4gdt3agl2usxyxv3xxyx39ul3xgytl5009q87l02j',
  'npub1cgd35mxmy37vhkfcmjckk9dylguz6q8l67cj6h9m45tj5rx569cql9kfex',

  'npub1jfn4ghffz7uq7urllk6y4rle0yvz26800w4qfmn4dv0sr48rdz9qyzt047',
  'npub1pj09u9lmma24aaqa4u7r5xt8f8yy37w8jxtx7v86uhjvqjqwsu9s7jznjh',
  'npub18dy8sffsw527dkgrwy90yw84y4nd7yq9cllmn6trje0kenp0lw9qpundjr',
  'npub1rzg96zjavgatsx5ch2vvtq4atatly5rvdwqgjp0utxw45zeznvyqfdkxve',
  'npub1lr2zzf989mvf393y0tv39ara6a4vddkd6y87z784up9vl6ks6j3qtudl6a',
  'npub1lxktpvp5cnq3wl5ctu2x88e30mc0ahh8v47qvzc5dmneqqjrzlkqpm5xlc',
  'npub1468024mrwz6uhywjvt8s6vw4e604egnv8tfd2m2utrmqyd3nu3fsutvgjn',
  'npub13kwjkaunpmj5aslyd7hhwnwaqswmknj25dddglqztzz29pkavhaq25wg2a',
  'npub1cwhy4k8qd2guyqz8t45u4yzyp4k4fhnjn573ukh6e77mde2dgm9s2lujc5',
  'npub1m2mvvpjugwdehtaskrcl7ksvdqnnhnjur9v6g9v266nss504q7mqvlr8p9',
  'npub1g9uxfl9ucrksgem38ne533qrmkv3g8wezzx4urhutactyxfzz7wsafz3nr',
  'npub1klkk3vrzme455yh9rl2jshq7rc8dpegj3ndf82c3ks2sk40dxt7qulx3vt',
  'npub13pnmakf738yn6rv2ex9jgs7924renmderyp5d9rtztsr7ymxg3gqej06vw',
  'npub1zrmu0amjmkynxlxgmdsyrjmp8vhxdz8ch5vja9vh9ym4natg8k5s8ge9wx',
  'npub1weev88wc43slz6jjlq2h30ltmd0ccu9utfe8wet2kkax0w6epavqw409xg',
  'npub19jk45jz45gczwfm22y9z69xhaex3nwg47dz84zw096xl6z62amkqj99rv7',
  'npub1e860dprl9jx8d9jwx73vymed8g2nl82wwgc72uzu39ftvdzu9y4qu2dhu9',
  'npub137c5pd8gmhhe0njtsgwjgunc5xjr2vmzvglkgqs5sjeh972gqqxqjak37w',
  'npub1r8mtwq33nnvxh6rzs4h25agp7czth4yndcqxayvvecfek2js6wyqpcwp63',
  'npub1xrs2z2tqvur2tsg9xq3ye2uy7nmxyjclrwzp3tr9r3g4dnewqx2qtz2hzv',
  'npub1yrffsyxk5hujkpz6mcpwhwkujqmdwswvdp4sqs2ug26zxmly45hsfpn8p0',
  'npub1njst6azswskk5gp3ns8r6nr8nj0qg65acu8gaa2u9yz7yszjxs9s6k7fqx',
  'npub1s05p3ha7en49dv8429tkk07nnfa9pcwczkf5x5qrdraqshxdje9sq6eyhe',
  'npub1xy04u0vum29hx3j6kzm9raaykakg6ru3kcgg88pywxqaxusyytsqvrpf8a',
  'npub1ghcetnluhryhynhuyj8s2pazldjm27wl40nu6dfeskvpv09twcnsneygat',
];
